import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Button } from "components/atoms/button/index";
import * as S from "./signup.styles";
import {
  Email,
  PasswordField,
  FirstName,
  LastName,
  whichRedirectDomains,
} from "./constants";
import { UserService } from "core/service/user.service";
import { Config } from "core/service/config.service";
import { useForm } from "react-hook-form";
import { Field } from "components/molecules/Field";
import { PasswordStrengthMeter } from "components/atoms/password-strength-meter/index";
import { ToolTipWrapper } from "components/atoms/tool-tip/index";
import { AuthService } from "core/service/auth.service";
import { UtilService } from "core/utils/utils";
import { BsEyeFill, BsEyeSlashFill } from "react-icons/bs";
import ReCAPTCHA from "react-google-recaptcha";

export const SignUpForm = () => {
  const { t } = useTranslation();
  const refCaptcha = useRef();
  const siteKey = Config.getCaptchaSiteKey();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid },
  } = useForm({ mode: "all" });

  const [showText, setShowText] = useState(false);
  const [affiliate, setAffiliate] = useState(false);
  const [refsite, setRefsite] = useState(false);
  const password = useRef({});
  password.current = watch("password", "");

  useEffect(() => {
    const affiliate = AuthService.getAffiliateDetails();
    const refsite = UtilService.getCookie("gst_ref_test");
    setAffiliate(affiliate);
    setRefsite(refsite);
  }, []);

  const onSubmit = async (values) => {
    const captchaToken = await refCaptcha.current.executeAsync();
    values.token = captchaToken;
    values.affiliate = affiliate.aff_id;
    values.affiliateName = affiliate.aff_name;
    values.refsite = refsite;
    UserService.signup(values).then((res) => {
      if (res && Object.keys(res.payload).length) {
        redirectToSimpletax();
      } else {
        refCaptcha.current.reset();
      }
    });
  };

  const redirectToSimpletax = () => {
    window.location.replace(
      `${whichRedirectDomains ? whichRedirectDomains : Config.getRedirectUrl()}`
    );
  };

  return (
    <S.SignupForm onSubmit={handleSubmit(onSubmit)}>
      <S.SignUpTitle>{t("signup.which.signup_header")}</S.SignUpTitle>
      <S.Container>
        <S.FieldContainerLeft>
          <S.FirstNameInput>
            {FirstName.map((obj, index) => (
              <Field
                /* todo: fix style into single props */
                font="small"
                top="top"
                {...obj}
                register={register}
                error={errors[obj.name]?.message}
                key={index}
              />
            ))}
          </S.FirstNameInput>
          <S.LastNameInput>
            {LastName.map((obj, index) => (
              <Field
                /* todo: fix style into single props */
                font="small"
                top="top"
                {...obj}
                register={register}
                error={errors[obj.name]?.message}
                key={index}
              />
            ))}
          </S.LastNameInput>
        </S.FieldContainerLeft>
      </S.Container>
      {Email.map((obj, index) => (
        <S.Container key={index} marginTop={60}>
          <Field
            /* todo: fix style into single props */
            {...obj}
            register={register}
            error={errors[obj.name]?.message}
            key={index}
            font="small"
            top="top"
          />
        </S.Container>
      ))}
      {PasswordField.map((obj, index) => (
        <S.Container key={index}>
          <Field
            ref={password}
            type={UtilService.setPasswordType(PasswordField, showText)}
            font="small"
            top="top"
            {...obj}
            register={register}
            error={errors[obj.name]?.message}
            key={index}
          />
          <S.EyeContainer>
            <S.Eye onClick={() => setShowText(!showText)}>
              {showText ? <BsEyeFill /> : <BsEyeSlashFill />}
            </S.Eye>
          </S.EyeContainer>
          <S.PasswordInfo>
            <ToolTipWrapper
              content={t("signup.password_validation")}
              position="right"
            />
          </S.PasswordInfo>
        </S.Container>
      ))}
      {password.current ? (
        <PasswordStrengthMeter value={password.current} />
      ) : (
        ""
      )}
      <ReCAPTCHA ref={refCaptcha} size="invisible" sitekey={siteKey} />
      <S.ButtonClass>
        <S.ButtonContainer>
          <Button
            size="610"
            background="#66D7D1"
            hover="#7986CB"
            transform="capitalize"
            value={t("signup.which.button")}
            disabled={!isValid ? true : false}
          />
        </S.ButtonContainer>
        <p>
          {t("signup.terms.message")}
          <Link to="/redirect-to-simpletax-terms">
            {t("signup.terms.link")}
          </Link>
        </p>
      </S.ButtonClass>
    </S.SignupForm>
  );
};
